import { usedExtent } from "./addr.js";
export const WORKBOOK_VERSION = 1;
export function serializeWorkbook(sheets, activeSheetId) {
    return JSON.stringify({
        v: WORKBOOK_VERSION,
        active: activeSheetId,
        sheets: sheets.map((s) => ({
            id: s.id,
            name: s.name,
            cells: Object.fromEntries(Object.entries(s.cells).map(([key, cell]) => [key, cell.src])),
            ...(s.colWidths && Object.keys(s.colWidths).length > 0 ? { cols: s.colWidths } : {}),
        })),
    });
}
export function deserializeWorkbook(json) {
    if (!json)
        return null;
    let data;
    try {
        data = JSON.parse(json);
    }
    catch {
        return null;
    }
    if (typeof data !== "object" || data === null)
        return null;
    const { v, active, sheets } = data;
    if (v !== WORKBOOK_VERSION || typeof active !== "string" || !Array.isArray(sheets) || sheets.length === 0)
        return null;
    const restored = [];
    for (const raw of sheets) {
        if (typeof raw !== "object" || raw === null)
            return null;
        const { id, name, cells, cols } = raw;
        if (typeof id !== "string" || typeof name !== "string" || typeof cells !== "object" || cells === null)
            return null;
        const entries = Object.entries(cells);
        if (entries.some(([, src]) => typeof src !== "string"))
            return null;
        const restoredCells = Object.fromEntries(entries.map(([key, src]) => [key, { src: src, value: null, error: null }]));
        const sheet = { id, name, cells: restoredCells, used: usedExtent(restoredCells) };
        if (cols !== undefined) {
            if (typeof cols !== "object" || cols === null)
                return null;
            if (Object.values(cols).some((w) => typeof w !== "number"))
                return null;
            sheet.colWidths = cols;
        }
        restored.push(sheet);
    }
    const activeSheetId = restored.some((s) => s.id === active) ? active : restored[0].id;
    return { sheets: restored, activeSheetId };
}
// Reads the raw value (jsonb string or object) without gating on version, so a future shape is detected rather than read as null.
export function parseStoredValue(value) {
    let data = value;
    if (typeof data === "string") {
        try {
            data = JSON.parse(data);
        }
        catch {
            return null;
        }
    }
    if (typeof data !== "object" || data === null)
        return null;
    const { v, active, sheets } = data;
    if (typeof v !== "number" || !Array.isArray(sheets))
        return null;
    return { version: v, active: typeof active === "string" ? active : "", sheets };
}
export function nextSheetNumber(sheets) {
    let max = 1;
    for (const s of sheets) {
        const m = /^s(\d+)$/.exec(s.id);
        if (m)
            max = Math.max(max, Number(m[1]));
    }
    return max + 1;
}
//# sourceMappingURL=serialize.js.map